export default __webpack_public_path__ + "static/media/na.29e28347.svg";